'use client'

import { useEffect, useState } from 'react'
import { getOpenStatus, type OperatingHours, type OpenStatus } from './openStatus'

/**
 * Estado de apertura reactivo para superficies de cliente.
 *
 * Devuelve `null` hasta el primer cálculo tras el mount: así el render del
 * servidor y el primer render del cliente coinciden (sin hydration mismatch) y,
 * mientras es null, la UI debe tratar el local como "desconocido" → no bloquear
 * (fail-open). Re-evalúa cada minuto para que el badge y el bloqueo crucen el
 * umbral de apertura/cierre sin recargar la página.
 */
export function useOpenStatus(
  operatingHours: OperatingHours | null,
  timezone: string | null,
  cutoffMinutes: number,
): OpenStatus | null {
  const [status, setStatus] = useState<OpenStatus | null>(null)

  useEffect(() => {
    const tz = timezone || 'America/Chicago'
    const compute = () => setStatus(getOpenStatus(operatingHours, tz, cutoffMinutes, new Date()))
    compute()
    const id = setInterval(compute, 60_000)
    return () => clearInterval(id)
  }, [operatingHours, timezone, cutoffMinutes])

  return status
}
